import React from "react";

export const NotFound404 = () => {
  return (
    <div>
      <h1>Too bad, page not found</h1>
    </div>
  );
};
